/* Loaded on every page. Product page: swaps the "feeling" blocks after a variant change and switches the product tabs.
   All pages: PDF links open in a new window. */
(function () {
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    // Dawn already fetched the section for the new variant; the block content is decided on the server.
    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      var id = event.data.sectionId;
      var root = document.querySelector(
        'product-info[data-section="' + id + '"], product-info[data-original-section="' + id + '"]'
      );
      if (!root || !event.data.html) return;

      root.querySelectorAll('[data-feeling-block]').forEach(function (current) {
        var next = event.data.html.querySelector('[data-feeling-block="' + current.dataset.feelingBlock + '"]');
        if (next) current.replaceWith(document.importNode(next, true));
      });
    });
  }

  function selectTab(list, tab) {
    list.querySelectorAll('[role="tab"]').forEach(function (other) {
      var selected = other === tab;
      other.setAttribute('aria-selected', selected ? 'true' : 'false');
      other.tabIndex = selected ? 0 : -1;
      var panel = document.getElementById(other.getAttribute('aria-controls'));
      if (panel) panel.hidden = !selected;
    });
  }

  document.addEventListener('click', function (event) {
    var tab = event.target.closest && event.target.closest('.feeling-tabs [role="tab"]');
    if (tab) selectTab(tab.parentElement, tab);
  });

  document.addEventListener('keydown', function (event) {
    var tab = event.target.closest && event.target.closest('.feeling-tabs [role="tab"]');
    if (!tab) return;

    var tabs = Array.from(tab.parentElement.querySelectorAll('[role="tab"]'));
    var index = tabs.indexOf(tab);
    var target = {
      ArrowRight: tabs[(index + 1) % tabs.length],
      ArrowLeft: tabs[(index - 1 + tabs.length) % tabs.length],
      Home: tabs[0],
      End: tabs[tabs.length - 1],
    }[event.key];
    if (!target) return;

    event.preventDefault();
    selectTab(tab.parentElement, target);
    target.focus();
  });

  // On click rather than in the markup, so this also covers links in texts maintained in the admin.
  document.addEventListener(
    'click',
    function (event) {
      var link = event.target.closest && event.target.closest('a[href]');
      if (!link || !/\.pdf$/i.test(link.pathname)) return;
      link.target = '_blank';
      link.relList.add('noopener');
    },
    true
  );
})();
